import { render } from "./tree-select.vue?vue&type=template&id=1f3b59fd&scoped=true"
import script from "./tree-select.vue?vue&type=script&lang=js"
export * from "./tree-select.vue?vue&type=script&lang=js"

import "./tree-select.vue?vue&type=style&index=0&id=1f3b59fd&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3b59fd"]])

export default __exports__